import { DocumentCard, Faq } from 'sections/Resources/FreightTemplates/ProformaInvoice/types';

export const documentsCardData: DocumentCard[] = [
  {
    id: 1,
    iconName: 'icon-files.svg',
    heading: 'Bill of Lading',
    url: '/resources/freight-templates/bill-of-lading',
    fileName: 'bill_of_lading',
  },
  {
    id: 2,
    iconName: 'icon-files.svg',
    heading: 'Freight Quotation',
    url: '/resources/freight-templates/freight-quotation',
    fileName: 'freight_quotation',
  },
  {
    id: 3,
    iconName: 'icon-files.svg',
    heading: 'Shipper\'s Letter of Instruction',
    url: '/resources/freight-templates/sli',
    fileName: "shipper's_letter_of_instruction",
  },
];

export const faq: Faq[] = [
  {
    id: "1",
    question: "What needs to be on a Proforma?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Mirror the final invoice as much as possible. Product details, <a class='${cn('faq__answer-link')}' href='https://www.df-alliance.com/blog/what-are-harmonised-system-hs-codes-in-shipping-'>HS codes</a>, unit price, total price, currency, and very important, an expiration date for the offer.
        </p>
      `
    ),
  },
  {
    id: "2",
    question: "Can I use the Proforma to clear customs?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Generally, no. Customs wants the final Commercial Invoice because the final value might have changed. However, some countries accept Proformas for pre-clearance or permit applications.
        </p>
      `
    ),
  },
  {
    id: "3",
    question: "Is the price on the Proforma binding?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          It’s binding for the validity period you state. If the buyer comes back three months later, and ocean freight rates have spiked, you are within your rights to issue a new Proforma.
        </p>
      `
    ),
  },
  {
    id: "4",
    question: "Why not just send a generic quote?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          A quote is informal. A Proforma is a recognized trade document. If your buyer needs bank financing, a generic email quote won't cut it. They need the formal structure of a Proforma.
        </p>
      `
    ),
  },
];